import React, { useEffect, useState } from "react";
import "./App.css";

// Importing Libraries:
// npm install react-router-dom
import { HashRouter as Router, Switch, Route } from "react-router-dom";

// font-Awesome lib: // npm install --save font-awesome
import "font-awesome/css/font-awesome.min.css";

//Others:
import { useStateValue } from "./utils/Provider/StateProvider";
import { db, auth, storage } from "./utils/User/include/Authorize";

// Import JS Components:
import Header from "./utils/header/Header";
import SubHeader from "./utils/header/SubHeader";
import Login from "./utils/User/Login";
import Home from "./components/Home";
import FloatOptions from "./components/FloatOptions";
import IndividualPersonView from "./components/IndividualPersonView";
import Error from "./components/Error";
import LinkFamily from "./components/LinkFamily";

// Ebox imports
import App1 from "./test/App1";
import App2 from "./Role/App1";
import RApp from "./test/reduxTest/RApp";
import RApp2 from "./test/reducerIasses/RApp2";
import FamilyTreeView from "./components/FamilyTreeView";
import CalendarView from "./components/CalendarView";

function App() {
  const [{ user }, dispatch] = useStateValue();

  const getDate = (i) => {
    var today, month, date;

    today = new Date();
    month = today.getMonth() + 1;
    date = today.getFullYear() + "-" + month + "-" + today.getDate();

    return date;
  };

  const getDiffInMonth = (i) => {
    var today = new Date();
    var curryear = today.getFullYear();

    var prevYear = i.split("-")[0];

    var diff = curryear - prevYear;
    if (diff === 11 || diff === 12 || diff === 13) {
      return diff + "th";
    }

    switch (diff % 10) {
      case 1:
        diff = diff + "st";
        break;

      case 2:
        diff = diff + "nd";
        break;

      case 3:
        diff = diff + "rd";
        break;

      default:
        diff = diff + "th";
        break;
    }

    return diff;

    // return ;
  };

  useEffect(() => {
    console.log("App initiated");
    const notification_arr = [];

    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        dispatch({
          type: "SET_USER",
          user: authUser,
        });

        // Getting my Family
        db.collection(authUser.email)
          .doc("Family")
          .collection("members")
          .onSnapshot((snapshot) => {
            const data = [];
            snapshot.forEach((doc) => {
              let obj = doc.data();
              obj["uuid"] = doc.id;
              data.push(obj);

              // BIRTHDAY NOTIFICATION:
              const today = getDate().split("-");

              try {
                const dob = obj.DOB.split("-");

                if (
                  parseInt(dob[1]) === parseInt(today[1]) &&
                  parseInt(dob[2]) === parseInt(today[2])
                ) {
                  const msg = {
                    title: "Birthday Party🎉",
                    desc:
                      obj.name +
                      " is celebrating his " +
                      getDiffInMonth(obj.DOB) +
                      " Birthday🥳 , wish him a very Good Day !",
                    date: obj.DOB,
                    to: "",
                    link: "",
                    link_text: "",
                  };

                  notification_arr.push(msg);
                }
              } catch (err) {
                console.log(err);
              }

              // Anniversary NOTIFICATION:

              try {
                const mAnni = obj.aniversary.split("-");

                if (
                  parseInt(mAnni[1]) === parseInt(today[1]) &&
                  parseInt(mAnni[2]) === parseInt(today[2])
                ) {
                  const msg = {
                    title: "Anniversary Party🎉",
                    desc:
                      obj.name +
                      " is celebrating his " +
                      getDiffInMonth(obj.aniversary) +
                      " Marriage Anniversary🥳 , wish him a very Good Day !",
                    date: obj.aniversary,
                    to: "",
                    link: "",
                    link_text: "",
                  };

                  notification_arr.push(msg);
                }
              } catch (err) {
                console.log(err);
              }

              // console.log('app >', data[0])
              dispatch({
                type: "MY_FAMILY",
                myfamily: data,
              });
            });
          });

        // Linked Family Members Details:
        db.collection(authUser.email)
          .doc("View")
          .collection("linkfamily")
          .onSnapshot((snapshot) => {
            const rel = [];

            snapshot.forEach((doc) => {
              let obj = doc.data();
              obj["uuid"] = doc.id;
              rel.push(obj);

              dispatch({
                type: "LINKED_FAMILY",
                linkedFamily: rel,
              });
            });
          });

        // Getting my Relative Family
        db.collection(authUser.email)
          .doc("Relative")
          .collection("members")
          .onSnapshot((snapshot) => {
            const rel = [];

            snapshot.forEach((doc) => {
              let obj = doc.data();
              obj["uuid"] = doc.id;
              rel.push(obj);

              dispatch({
                type: "MY_RELATIVE",
                myrelative: rel,
              });

              Object.keys(obj.person_data).map((i) => {
                // BIRTHDAY NOTIFICATION:

                try {
                  const dob = obj.person_data[i].DOB.split("-");
                  const today = getDate().split("-");

                  // today birthday:
                  if (
                    parseInt(dob[1]) === parseInt(today[1]) &&
                    parseInt(dob[2]) === parseInt(today[2])
                  ) {
                    const msg = {
                      title: "Birthday Party🎉",
                      desc: (
                        <>
                          <b>{obj.person_data[i].name}</b> is celebrating his{" "}
                          {getDiffInMonth(obj.person_data[i].DOB)} Birthday🥳,
                          Wish him a very Good Day !
                        </>
                      ),
                      date: obj.person_data[i].DOB,
                      to: "",
                      link: "",
                      link_text: "",
                    };

                    notification_arr.push(msg);
                  } else if (
                    parseInt(dob[2]) > parseInt(today[2]) &&
                    parseInt(dob[1]) === parseInt(today[1])
                  ) {
                    const msg = {
                      title: "(upcomming) Birthday Party🎉",
                      desc: (
                        <>
                          <b>{obj.person_data[i].name}</b> will be celebrating
                          his {getDiffInMonth(obj.person_data[i].DOB)}{" "}
                          Birthday🥳, this month !
                        </>
                      ),
                      date: obj.person_data[i].DOB,
                      to: "",
                      link: "",
                      link_text: "",
                    };

                    notification_arr.push(msg);
                  } else if (parseInt(dob[1]) === parseInt(today[1]) + 1) {
                    const msg = {
                      title: "(upcomming) Birthday Party🎉",
                      desc: (
                        <>
                          <b>{obj.person_data[i].name}</b> will be celebrating
                          his {getDiffInMonth(obj.person_data[i].DOB)}{" "}
                          Birthday🥳,next month !
                        </>
                      ),
                      date: obj.person_data[i].DOB,
                      to: "",
                      link: "",
                      link_text: "",
                    };

                    notification_arr.push(msg);
                  }
                } catch (err) {}

                // Aniversary Notification
                try {
                  if (obj.person_data[i].aniversary) {
                    const dob = obj.person_data[i].aniversary.split("-");
                    const today = getDate().split("-");

                    if (
                      parseInt(dob[1]) === parseInt(today[1]) &&
                      parseInt(dob[2]) === parseInt(today[2])
                    ) {
                      const msg = {
                        title: "Anniversary Party🎉",
                        desc: (
                          <>
                            <b>{obj.person_data[i].name}</b> is celebrating his{" "}
                            {getDiffInMonth(obj.person_data[i].aniversary)}{" "}
                            Marriage Anniversary🥳, Wish him a very Good Day !"
                          </>
                        ),
                        date: obj.person_data[i].aniversary,
                        to: "",
                        link: "",
                        link_text: "",
                      };

                      notification_arr.push(msg);
                    } else if (
                      parseInt(dob[2]) > parseInt(today[2]) &&
                      parseInt(dob[1]) === parseInt(today[1])
                    ) {
                      const msg = {
                        title: "(upcomming) Anniversary Party🎉",
                        desc: (
                          <>
                            <b>{obj.person_data[i].name}</b> will be celebrating
                            his {getDiffInMonth(obj.person_data[i].aniversary)}{" "}
                            Marriage Anniversary🥳, this month !
                          </>
                        ),
                        date: obj.person_data[i].aniversary,
                        to: "",
                        link: "",
                        link_text: "",
                      };

                      notification_arr.push(msg);
                    } else if (parseInt(dob[1]) === parseInt(today[1]) + 1) {
                      const msg = {
                        title: "(upcomming) Anniversary Party🎉",
                        desc: (
                          <>
                            <b>{obj.person_data[i].name}</b> will be celebrating
                            his {getDiffInMonth(obj.person_data[i].aniversary)}{" "}
                            Marriage Anniversary🥳, next month !
                          </>
                        ),
                        date: obj.person_data[i].aniversary,
                        to: "",
                        link: "",
                        link_text: "",
                      };

                      notification_arr.push(msg);
                    }
                  }
                } catch (err) {}
              });
            });
          });

        // Fetch Global relative mappers:
        db.collection("App")
          .doc("global")
          .collection("relations")
          .onSnapshot((snapshot) => {
            let data;

            snapshot.forEach((doc) => {
              let obj = doc.data();

              dispatch({
                type: "MAP_OF_RELATIVE_DESC",
                mapRelativeDesc: obj.data,
              });
            });
          });
      } else {
        dispatch({
          type: "NOTIFY_ERROR",
          error: "Kindly, Login with your credentials !",
        });
      }

      // lOOKING FOR system notifications:
      try {
        db.collection("sysnotification").onSnapshot((snapshot) => {
          snapshot.forEach((doc) => {
            let obj = doc.data();
            obj["uuid"] = doc.id;
            notification_arr.push(obj);
          });

          dispatch({
            type: "SET_NOTIFICATION",
            notify: notification_arr,
          });
        });
      } catch {
        console.log("No Notifications Avaiable");
      }
    });
  }, [user]);

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/login">
            <Header />
            <Login />
            <Error />
          </Route>

          {/* <Route path='/home'>
          <Header />
          <SubHeader />
          <p>Home Page</p>
          <Error />
        </Route> */}

          {/* <Route path='/ebox/1'>
          <App1 />
        </Route> */}

          {/* <Route path='/ebox/2'>
          <App2 />
        </Route> */}

          <Route path="/ebox/3">
            {/* <RApp /> */}
            <RApp2 />
          </Route>

          <Route path="/link/family">
            <Header />
            <SubHeader />
            <LinkFamily />
            <Error />
          </Route>

          <Route path="/tree">
            <Header />
            <SubHeader />
            <FamilyTreeView />
            <Error />
          </Route>

          <Route path="/person/individualView">
            <Header />
            <SubHeader />
            <IndividualPersonView />
            <FloatOptions />
            <Error />
          </Route>

          <Route path="/u/events">
            <Header />
            <SubHeader />
            <CalendarView />
            <Error />
          </Route>

          <Route path="/">
            <Header />
            <SubHeader />
            <Home />
            <FloatOptions />
            <Error />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
